module.exports = __webpack_public_path__ + "static/img/nothing.5f7d9541.png";